import { t } from "i18next"
import { type Dispatch, type SetStateAction, useEffect, useState } from "react"
import { Pkm } from "../../../../../types/enum/Pokemon"
import type { IDetailledPokemon } from "../../../models/bot-v2"
import { LocalStoreKeys, localStore } from "../../utils/store"
import { Modal } from "../modal/modal"
import TeamBuilder from "./team-builder"

const MAX_TEAM_PLANNER_SIZE = 24

function loadTeamPlanner(): IDetailledPokemon[] {
  const stored = localStore.get(LocalStoreKeys.TEAM_PLANNER)
  if (!Array.isArray(stored)) return []

  const occupiedCells = new Set<string>()
  return stored
    .slice(0, MAX_TEAM_PLANNER_SIZE)
    .filter((pokemon): pokemon is IDetailledPokemon => {
      if (
        !pokemon ||
        typeof pokemon !== "object" ||
        !Object.values(Pkm).includes(pokemon.name) ||
        !Number.isInteger(pokemon.x) ||
        pokemon.x < 0 ||
        pokemon.x >= 8 ||
        !Number.isInteger(pokemon.y) ||
        pokemon.y < 1 ||
        pokemon.y > 3 ||
        !Array.isArray(pokemon.items)
      ) {
        return false
      }

      const cell = `${pokemon.x},${pokemon.y}`
      if (occupiedCells.has(cell)) return false
      occupiedCells.add(cell)
      return true
    })
}

export default function TeamBuilderModal(props: {
  show: boolean
  handleClose: Dispatch<SetStateAction<void>>
}) {
  const [board, updateBoard] = useState<IDetailledPokemon[]>(loadTeamPlanner)
  useEffect(() => {
    localStore.set(LocalStoreKeys.TEAM_PLANNER, board)
  }, [board])

  return (
    <Modal
      show={props.show}
      onClose={props.handleClose}
      header={t("team_builder")}
      className="team-builder-modal"
    >
      <TeamBuilder board={board} updateBoard={updateBoard} />
    </Modal>
  )
}
